<template>
  <div class="searchbox">
    <div
      v-if="boxNameAction == 'all'"
      id="searchBox"
      class="search"
      :class="{
      'is-active' : isActive,
      'searchActionCss' : isActive || S_GlobalSearch,
      'searchDellCss' : !isActive,
    }"
      @keyup.enter="searchfs($event)"
      @click="searchAction($event)"
    >
      <el-input
        class="search-input"
        v-model="keyword"
        :placeholder="`搜索${spriteType}`"
        @select="searchfs"
        @focus="togglePreventDefault(false, $event); isActive=true; inputFocus()"
        @blur="togglePreventDefault(true, $event);   isActive=false"
      ></el-input>
    </div>
    <div
      v-if=" !isActive && boxNameAction == 'all'"
      v-show="!S_GlobalSearch || !keyword.length"
      class="upLoadBtn"
      @click="uploadFs($event)"
      v-loading="upLoadingDown"
    >{{upLoadingDown ? '' : '上传'}}</div>

    <el-tooltip
      v-if="boxNameAction == 'all'"
      effect="dark"
      content="搜索"
      placement="bottom"
      :open-delay="1000"
    >
      <i
        :class="{
        'search-out-icon': S_GlobalSearch,
      }"
        :style="{
        'right' : S_GlobalSearch ? '20px' : '75px',
      }"
        @click="closeSearchfs($event)"
        v-if="S_GlobalSearch && !isActive"
      ></i>
      <i
        class="search-icon"
        :class="{
        'search-iconDel'    : isActive || S_GlobalSearch,
        'search-iconAction' : !isActive,
      }"
        v-if="!S_GlobalSearch || isActive"
        @focus="searchfs($event, 'icon')"
      ></i>
    </el-tooltip>
    <!-- <div class v-if="boxNameAction == 'userExtensions'">
      <span v-if="UserExtensions == 1">
        您可上传并共享素材给子账号。
        <a
          class="hrefLink"
          target="_black"
          href="/userCenter?userCenterTab=Accountsystem"
        >共享资源</a>
      </span>

      <span v-if="UserExtensions == 2">此处资源为父账号共享给您的资源</span>
    </div>-->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Analysis from "../mixins/analysis/materialBu";

export default {
  mixins: [Analysis],
  data () {
    return {
      isActive: false,
      spriteType: "场景",
      spriteTag: 12,
      keyword: "", // 搜索关键字
      SearchMsgList: [], // 搜索数据列表
      upLoadingDown: false, // 上传loading动画
      boxNameAction: "all", // 判断区块
      personalTab: "personalCategory",
      recommendTag: [],
      rightNavFirstOpenFlag: false
    };
  },
  props: ["boxData"],
  watch: {
    "boxData.type" (val) {
      this.boxNameAction = "all";
      switch (val) {
        case "bg":
          this.spriteType = "背景";
          this.spriteTag = 3;
          break;
        case "text":
          this.spriteType = "文字";
          this.spriteTag = 16;
          break;
        case "characters":
          this.spriteType = "角色";
          this.spriteTag = 14;
          break;
        case "props":
          this.spriteType = "道具";
          this.spriteTag = 17;
          break;
        case "shapes":
          this.spriteType = "形状";
          this.spriteTag = 15;
          break;
        case "sound":
          this.spriteType = "声音";
          this.spriteTag = 5;
          break;
        case "gif":
          this.spriteType = "GIF";
          this.spriteTag = 37;
          break;
        case "scenes":
          this.spriteType = "场景";
          this.spriteTag = 12;
          break;
        case "template":
          this.spriteType = "模板";
          this.spriteTag = "home/template";
          break;
        case "personal":
          this.spriteType = "场景";
          this.spriteTag = 12;
          break;
        default:
          this.boxNameAction = val;
          this.spriteType = "场景";
          this.spriteTag = 12;
          break;
      }
    },
    MaterialPane_Size: {
      handler (val) {
        if (val.width > 95 && !this.rightNavFirstOpenFlag) {
          this.rightNavFirstOpenFlag = true;
          this.$http.get("/api/common/material/recommendTag").then(data => {
            // 获取热门搜索
            if (data.data.code == 200) {
              this.recommendTag = data.data.data;
            }
          });
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters([
      "TopNav_Size",
      "MaterialPane_Size",
      "S_GlobalSearch",
      "StyleMsg"
    ]),
    ...mapGetters({
      trackingData: 'tracking/trackingData'
    })
  },
  mounted () {
    this.$bus.on("search-OpenClose", data => {
      if (data.type) {
        switch (data.type) {
          case "history":
            this.$bus.emit("FeaturesPop_close_vue", {
              name: "searchHistroy",
              type: 1
            });
            this.keyword = data.value;
            break;
        }
      }
      this.searchfs();
    });
    this.$bus.on("upLoadingDown_vue", data => {
      switch (data.type) {
        case 0:
          this.upLoadingDown = true;
          break;
        case 1:
          this.upLoadingDown = false;
          break;
      }
    });
    this.$bus.on("upload_vue", data => {
      this.upLoadingDown = false;
    });

    // this.$bus.on('personal_tab_FS_new_vue', data => { // 个人资源列表切换按钮迁移到我的
    //   if(this.personalTab != data.type){
    //     this.personalTabFS(data.type);
    //   }
    // });
    this.$bus.on("CloseGlobalSearch", data => {
      this.keyword = "";
    });
  },
  methods: {
    inputFocus () {
      sensors.track('searchClick', {
        search_source: '编辑器素材栏'
      });
    },
    togglePreventDefault (val, e) {
      // 是否启用快捷键
      this.$bus.emit("manageMaterial_vue", { step: 0 }); // 取消批量管理
      this.$store.commit("toggle_isPreventDefault", val);
    },
    closeSearchfs (e) {
      if (this.S_GlobalSearch || !this.keyword.trim()) {
        this.$store.commit("save_SearchClose", true);
        this.keyword = "";
        if (e) {
          e.target.blur();
          e.stopPropagation();
        }
      }
    },
    searchfs (e, type) {
      if (e && !type) {
        e.target.blur();
        e.stopPropagation();
        this.$bus.emit("FeaturesPop_close_vue", {
          name: "searchHistroy",
          type: 1
        });
      }
      switch (
      type // icon搜索
      ) {
        case "icon":
          e.stopPropagation();
          break;
      }
      if (!this.keyword && e) {
        return;
      }

      // 弹出气泡提示
      this.$bus.emit("showTips", {
        text:
          "红色数字代表了我们在每个分类下找到的素材数量，点击不同分类可进行查看；删除搜索关键字可退出搜索状态。",
        position: {
          top: `${this.TopNav_Size.height + 10}px`,
          left: `${this.MaterialPane_Size.width +
            (this.boxData.type == "scenes" ? 290 : 0)}px`
        }
      });

      this.$http
        .get("/api/common/material/findAll", {
          params: {
            style: this.StyleMsg,
            sOfPage: 18,
            pIndex: 1,
            keyword: this.keyword,
            type: this.spriteTag
          }
        })
        .then(res => {
          let data = res.data.data;
          this.$store.commit("save_SearchData", {
            data: this.keyword,
            scenes: data.sceneTotal || 0, // 场景
            text: data.textTotal || 0, // 文字
            shapes: data.shapeTotal || 0, // 形状
            bg: data.bgTotal || 0, // 背景
            props: data.propTotal || 0, // 道具
            sound: data.musicTotal || 0, // 音乐
            characters: data.characterTotal || 0, // 角色
            gif: data.gifTotal || 0, // GIF
            template: data.templateTotal || 0 // 模版
          });
          let names = {
            3: '背景',
            5: '音乐',
            8: '模板',
            12: '场景页',
            14: '人物',
            16: '文字',
            17: '道具',
            'home/template': '模板'
          }
          let totalDict = {
            '背景': data.bgTotal,
            '音乐': data.musicTotal,
            '模板': data.templateTotal,
            '场景页': data.sceneTotal,
            '人物': data.characterTotal,
            '文字': data.textTotal,
            '道具': data.propTotal,
          }
          let keys = Object.keys(data);
          let total = keys.reduce((memo, key) => {
            return memo + data[key]
          }, 0);
          sensors.track('searchResult', {
            search_source: '编辑器素材栏',
            keyword: this.keyword,
            has_result: !!totalDict[names[this.spriteTag]],
            material_type: names[this.spriteTag],
            search_type: this.spriteTag === 'home/template' ? '模板' : '素材搜索',
            search_result_num: totalDict[names[this.spriteTag]],
            keyword_type: this.trackingData.keyword_type || '手动输入',
          });
          this.$store.commit('tracking/setTrackingData', {
            search_type: this.spriteTag == 8 ? '模板搜索' : '素材搜索',
            keyword: this.keyword,
            choose_price: '全部价格',
            order_method: '综合排序',
          });
          this.addSearchMsgList();
        });
    },
    querySearch (queryString, cb) {
      let worksJson = this.$util.localStorage.get("SEARCH_history_record");
      this.SearchMsgList = worksJson || [];
      let data = this.SearchMsgList;
      // 调用 callback 返回建议列表的数据
    },
    addSearchMsgList () {
      let item = { value: this.keyword };
      for (let i = 0; i < this.SearchMsgList.length; i++) {
        if (this.SearchMsgList[i].value === item.value) {
          this.SearchMsgList.splice(i, 1);
        }
      }
      if (this.SearchMsgList.length < 5) {
        this.SearchMsgList.unshift(item);
      } else {
        this.SearchMsgList.unshift(item);
        this.SearchMsgList.pop();
      }
      this.pushSearchData();
      let data = JSON.stringify(this.SearchMsgList);
      this.$util.localStorage.set("SEARCH_history_record", data);
    },
    searchAction (e) {
      // 有搜索状态的时候，点击取消掉搜索状态
      this.querySearch();
      let domPosition = document.getElementById("searchBox");
      let top = domPosition.getBoundingClientRect().top,
        left = domPosition.getBoundingClientRect().left;
      this.$bus.emit("FeaturesPop_vue", {
        type: 1, // 弹窗的类型 1级弹窗 < 2级弹窗
        name: "searchHistroy",
        sprite: null,
        posx: left - 17,
        posy: top,
        recommendTag: this.recommendTag
      });
    },
    uploadFs (e) {
      if (this.upLoadingDown) return;
      this.$bus.emit("manageMaterial_vue", { step: 0 }); // 取消批量管理
      this.materialPushAnalysis({ type: "Upload" });
      this.$bus.emit("FeaturesPop_vue", {
        type: 1, // 弹窗的类型 1级弹窗 < 2级弹窗
        name: "uploadFile",
        sprite: null,
        posx: e.pageX - e.offsetX,
        posy: e.pageY - e.offsetY + 34
      });
    },
    pushSearchData () {
      let dataList = Array.from(this.SearchMsgList);
      this.SearchMsgList = [];
      if (this.recommendTag.length) {
        this.searchData = [];
        for (let j = 0; j < dataList.length; j++) {
          let addJudge = true;
          let dataItem = dataList[j];

          for (let i = 0; i < this.recommendTag.length; i++) {
            let tagsItem = this.recommendTag[i];

            if (tagsItem.name == dataItem.value) {
              addJudge = false;
              break;
            }
          }
          if (addJudge) {
            this.SearchMsgList.push(dataItem);
          }
        }
      } else {
        this.SearchMsgList = [];
      }
    }
    // personalTabFS(data){ // 个人资源列表切换按钮迁移到我的
    //   this.personalTab = data;
    //   this.$bus.emit('personal_tab_FS_vue',{
    //     type : this.personalTab,
    //   });
    //   if(data == 'collectionCategory'){
    //     this.materialPushAnalysisTwo('personalTabFS')
    //   }
    // }
  },
  components: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.search-input {
  &:focus {
    outline: none;
  }
  .el-input:focus {
    outline: none;
  }
  input {
    border: none;
  }
}
</style>
<style scoped lang="scss">
.searchbox {
  position: absolute;
  // top: 60px;
  right: 0;
  // display: flex;
  // align-items: center;
  // justify-content: space-around;
  // flex-direction: column;
  width: 290px;
  height: 36px;
  background-color: #fff;

  .hrefLink {
    color: #5175ff;

    &:hover {
      color: #5175ff;
    }
  }
  .search {
    position: absolute;
    left: 10px;
    z-index: 5;
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin: 0 auto;
    height: 36px;
    border-radius: 20px;
    border: 1px solid #d4d4e7;
    background-color: #fff;
    overflow: hidden;
    transition: all 0.3s;
    .search-input {
      margin-left: -20px;
    }
    input {
      outline: none;
      border: none;
      width: 200px;
      height: 38px;
      margin-left: 15px;
    }
  }
  .searchDellCss {
    width: 200px;
    .search-input {
      width: 170px;
    }
  }
  .searchActionCss {
    width: 270px;

    .search-input {
      width: 240px;
    }
  }

  > i {
    position: absolute;
    width: 20px;
    height: 20px;
    line-height: 20px;
  }
  .upLoadBtn {
    position: absolute;
    left: 220px;
    width: 60px;
    height: 36px;
    background-color: #5778fb;
    border-radius: 8px;
    font-size: 14px;
    color: #ffffff;
    line-height: 36px;
    cursor: pointer;

    &:hover {
      background-color: #7d95f5;
    }
  }
  i.search-icon {
    top: 8px;
    display: inline-block;
    z-index: 5;
    margin-right: 16px;
    cursor: pointer;
    width: 20px;
    height: 20px;
    background: url('../../../static/svg/search.svg') no-repeat center;
    transition: all 0.3s;
    &:hover {
      background: url('../../../static/svg/search-active.svg') no-repeat center;
    }
  }
  .search-iconAction {
    right: 75px;
  }

  .search-iconDel {
    right: 20px;
  }
  .search-out-icon {
    //
    top: 8px;
    cursor: pointer;
    background: url('../../../static/svg/close-search.svg') no-repeat center;
    z-index: 10;

    &:hover {
      background: url('../../../static/svg/close-search-active.svg') no-repeat
        center;
    }
  }
  .is-active {
    border: 1px solid #5778fb;
    box-shadow: 0 0 1px 1px #5778fb;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/rightnav/search.vue